import type { ComponentProps, ReactNode } from "react";
import { PageHeader } from "@NP-Webber/crm-kit/dist/next/index.js";
import { useShell } from "../shell/ShellContext";

type PageHeaderProps = ComponentProps<typeof PageHeader>;

export type ScreenHeaderProps = Omit<PageHeaderProps, "title"> & {
  /** defaults to the label of the current menu item */
  title?: ReactNode;
};

/**
 * ScreenHeader — the new-design page header of every screen: the title comes from the menu
 * (so the sidebar and the page always agree), plus a sub line, ONE primary action and grouped menus.
 * The "?" beside the title (help for this screen) is added by PageHeader when guides exist.
 */
export function ScreenHeader({ title, ...rest }: ScreenHeaderProps) {
  const { current } = useShell();
  return <PageHeader title={title ?? current?.label ?? ""} {...rest} />;
}

export default ScreenHeader;
